import { useState } from "react";
import { Box, Button, MenuItem, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import FacultyList from "../../faculty/components/FacultyList";
import StaffList from "../components/StaffList";
import { StaffType, StaffTypeLabel } from "../types";
import { toolbarButtonSx, toolbarFieldsSx } from "../../../components/common/toolbarStyles";
import { StaffTypeToggle, useStaffKind } from "./StaffTypeToggle";

/**
 * Staff → Directory: Faculty (default) or support staff. Top bar: tabs on the left; on the right the
 * Role filter (Staff tab only) and the Add button for the selected kind.
 */
export default function StaffDirectoryPage() {
  const navigate = useNavigate();
  const [kind, setKind, canManageFaculty] = useStaffKind();
  const [role, setRole] = useState<StaffType>(StaffType.LIBRARIAN);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt: 2, mr: 2 }}>
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" sx={{ borderBottom: 1, borderColor: "divider", pb: 1 }}>
        {canManageFaculty && <StaffTypeToggle kind={kind} onChange={setKind} />}
        <Box flexGrow={1} />
        {kind === "staff" && (
          <TextField
            select
            size="small"
            label="Role"
            value={role}
            onChange={(event) => setRole(event.target.value as StaffType)}
            sx={{ ...toolbarFieldsSx, minWidth: 140 }}
          >
            {Object.entries(StaffTypeLabel).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        )}
        <Button variant="contained" size="small" sx={toolbarButtonSx} startIcon={<AddIcon />} onClick={() => navigate(`/app/staff/new?type=${kind}`)}>
          Add {kind === "faculty" ? "Faculty" : "Staff"}
        </Button>
      </Box>
      {kind === "faculty" ? <FacultyList /> : <StaffList role={role} />}
    </Box>
  );
}
